import classNames from 'classnames';
import CategoryBox from 'components/CategoryBox';
import {useWholesaler} from 'context/wholesaler';
import {useLocation, useNavigate} from 'react-router-dom';
import {categoryItems} from 'utilities/helper/categoryItems/categoryItems';

const CategoryList = ({title, route, appType}: ICategoryListProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {updateTypeOfAd} = useWholesaler();
  return (
    <>
      <p className=" text-center  mt-8 mb-8">{title}</p>
      <div
        className={classNames(
          'grid gap-4 grid-cols-2',
          appType === 'farm' ? 'mx-2' : 'mx-6',
        )}
      >
        {categoryItems.map(item => (
          <div
            key={item.id}
            onClick={() => {
              if (appType === 'wholesaler') {
                if (item.id === 0) {
                  updateTypeOfAd('post');
                  navigate(route);
                } else {
                  updateTypeOfAd('wanted');
                  navigate(location.pathname + item.route);
                }
              } else {
                item.id === 0
                  ? navigate(route)
                  : navigate(location.pathname + item.route);
              }
            }}
          >
            <CategoryBox
              icon={appType === 'wholesaler' ? item.marketIcon : item.icon}
              title={item.title}
              disabled={true}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default CategoryList;
